import { gql } from '@parkchirp/api-client';

export const SET_HOURLY_ACCOUNT_CONFIG = gql`
    mutation setHourlyAccountConfig(
        $accountId: String!,
        $feature: HourlyAccountConfigFeatureEnum!,
        $config: String!
    ) {
        setHourlyAccountConfig(
            accountId: $accountId,
            feature: $feature,
            config: $config
        ) {
            accountId
            feature
            config
        }
    }
`;
